import { render, staticRenderFns } from "./DisplaySettingsPerAssignee.vue?vue&type=template&id=fa364588&scoped=true&"
import script from "./DisplaySettingsPerAssignee.vue?vue&type=script&lang=js&"
export * from "./DisplaySettingsPerAssignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa364588",
  null
  
)

export default component.exports